/* MT home only — deferred and browser-cacheable. */
(() => {
      const root = document.getElementById('mt-ugc-2026');
      if (!root || root.dataset.ready) return;
      root.dataset.ready = 'true';
      const rail = root.querySelector('.mt-v-rail');
      const cards = [...root.querySelectorAll('.mt-v-card')];
      const more = root.querySelector('.mt-v-more');
      const dialog = root.querySelector('.mt-v-dialog');
      const player = root.querySelector('.mt-v-modal-video');
      const title = root.querySelector('.mt-v-modal-title');
      const modalLink = root.querySelector('.mt-v-modal-link');
      const error = root.querySelector('.mt-v-error');
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const saveData = navigator.connection && navigator.connection.saveData;
      const mobile = window.matchMedia('(max-width: 767px)');
      const moreWrap = root.querySelector('.mt-v-more-wrap');
      let expanded = false;
      const ratios = new Map();
      let playingCards = new Set();

      const pending = new WeakSet();
      const blocked = new WeakSet();
      const hints = new Map();
      cards.forEach(card => {
        const preview = card.querySelector('.mt-v-preview');
        const hint = document.createElement('span');
        hint.className = 'mt-v-play-hint';
        hint.textContent = 'Lire la vidéo';
        hint.setAttribute('aria-hidden', 'true');
        hint.hidden = !motion.matches && !saveData;
        preview.appendChild(hint);
        preview.setAttribute('aria-haspopup', 'dialog');
        preview.setAttribute('role', 'button');
        preview.addEventListener('keydown', event => {
          if (event.key === ' ') { event.preventDefault(); preview.click(); }
        });
        hints.set(card, hint);
      });

      function pausePreview() {
        cards.forEach(card => card.querySelector('video').pause());
      }
      function loadPreview(video, playback = false) {
        if (video.closest('.mt-v-card').hidden || (saveData && !playback)) return;
        video.muted = true;
        video.preload = playback ? 'auto' : 'metadata';
        if (!video.getAttribute('src')) {
          video.src = video.dataset.src;
          video.load();
        }
      }
      function isVisible(card) {
        return !card.hidden && !dialog.open && !document.hidden &&
          !motion.matches && !saveData && (ratios.get(card) || 0) >= .25;
      }
      function shouldPlay(card) { return isVisible(card) && playingCards.has(card); }
      function syncPreview() {
        playingCards = new Set(cards.filter(isVisible).sort((a,b) => (ratios.get(b)||0)-(ratios.get(a)||0)).slice(0,2));
        cards.forEach(card => {
          const video = card.querySelector('video');
          const hint = hints.get(card);
          hint.hidden = 'IntersectionObserver' in window && !motion.matches && !saveData && !blocked.has(video);
          if (!shouldPlay(card)) { video.pause(); return; }
          if (blocked.has(video) || pending.has(video)) return;
          loadPreview(video, true);
          if (!video.paused) return;
          pending.add(video);
          video.play().then(() => {
            pending.delete(video);
            if (!shouldPlay(card)) video.pause();
          }).catch(error => {
            pending.delete(video);
            if (error.name !== 'AbortError') {
              blocked.add(video);
              hint.hidden = false;
            }
          });
        });
      }
      function syncCards() {
        const revealAll = mobile.matches || expanded;
        cards.slice(4).forEach(card => {
          if (!revealAll && card.contains(document.activeElement)) {
            cards[0].querySelector('.mt-v-preview').focus({preventScroll:true});
          }
          card.hidden = !revealAll;
          if (card.hidden) ratios.set(card, 0);
          if (!('IntersectionObserver' in window) && !card.hidden) {
            loadPreview(card.querySelector('video'));
          }
        });
        moreWrap.hidden = revealAll;
        more.hidden = revealAll;
        syncPreview();
      }
      syncCards();
      mobile.addEventListener('change', syncCards);

      if ('IntersectionObserver' in window) {
        const preload = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) loadPreview(entry.target, shouldPlay(entry.target.closest('.mt-v-card')));
          });
        }, {rootMargin:'120px 0px'});
        cards.forEach(card => preload.observe(card.querySelector('video')));
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => ratios.set(entry.target, entry.intersectionRatio));
          syncPreview();
        }, {threshold:[0,.25,.5,.75,1]});
        cards.forEach(card => observer.observe(card));
      } else {
        cards.forEach(card => {
          loadPreview(card.querySelector('video'));
          hints.get(card).hidden = false;
        });
      }
      document.addEventListener('visibilitychange', () => { if(document.hidden)player.pause(); syncPreview(); });
      motion.addEventListener('change', syncPreview);

      cards.forEach(card => card.querySelector('.mt-v-preview').addEventListener('click', event => {
        event.preventDefault();
        pausePreview();
        const tile = card.querySelector('video');
        title.textContent = card.dataset.title;
        modalLink.href = card.dataset.href;
        modalLink.setAttribute('aria-label', 'Voir la gamme ' + card.dataset.title);
        error.hidden = true;
        player.src = tile.dataset.src;
        player.muted = false;
        dialog.showModal();
        player.currentTime = 0;
        player.play().catch(() => {});
      }));
      player.addEventListener('error', () => { error.hidden = false; });
      root.querySelector('.mt-v-close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => {
        player.pause();
        player.removeAttribute('src');
        player.load();
        error.hidden = true;
        syncPreview();
      });
      more.addEventListener('click', () => {
        const extra = cards.slice(4);
        expanded = true;
        syncCards();
        extra[0].querySelector('.mt-v-preview').focus({preventScroll:true});
        if (!('IntersectionObserver' in window)) extra.forEach(card => loadPreview(card.querySelector('video')));
        if (mobile.matches) {
          rail.scrollTo({left: extra[0].offsetLeft-cards[0].offsetLeft, behavior: motion.matches ? 'auto' : 'smooth'});
        }
        syncPreview();
      });
    })();
